import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IPlanTree } from '../../services/IPlanTree';
import { IStep } from '../../services/IStep';
import { IDomain } from '../../services/IDomain';
import { StepComponent } from '../step.component';
import { PlanCoordinate } from '../../services/plan-coordinate';
import { PlanDomain } from '../../services/PlanDomain';
import { PlanStep } from '../../services/PlanStep';


@Component({
  selector: 'app-plan-tree',
  templateUrl: './plan-tree.component.html',
  styleUrls: ['./plan-tree.component.scss']
})
export class PlanTreeComponent implements OnInit, OnChanges {
  @Output() planCoordinateClick = new EventEmitter<PlanCoordinate>();
  @Input() planTree: IPlanTree;
  @Input() planCoordinate: PlanCoordinate;

  constructor() { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    StepComponent.logNgOnChanges(changes);
  }

  get domains(): IDomain[] {
    return this.planTree.domains.filter(d => d.planDomain !== PlanDomain.OUTPUTS);
  }

  get outputs(): IDomain {
    return this.planTree.domains.find(d => d.planDomain === PlanDomain.OUTPUTS);
  }

  get outputsStep(): IStep {
    return this.planTree.getStep(PlanCoordinate.stepBy(PlanStep.OUTPUTS));
  }

  isSelected(step: IStep): boolean {
    return this.planCoordinate.planStep === step.planStep;
  }

  get isOutputsSelected(): boolean {
    return this.planCoordinate.planDomain === PlanDomain.OUTPUTS;
  }

  get strategyName() {
    return this.planTree.strategyName;
  }

  get targetStartDate() {
    return this.planTree.targetStartDate;
  }

  get targetEndDate() {
    return this.planTree.targetEndDate;
  }

  onStepClick(step: IStep) {
    this.planCoordinateClick.emit(PlanCoordinate.stepBy(step.planStep));
  }
}
